"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAlertSeverity = void 0;
var _basketUpdated = require("@ori-events/basket-updated");
const getAlertSeverity = (type)=>{
    switch(type){
        case _basketUpdated.ShoppingNotificationType.Error:
            return 'error';
        case _basketUpdated.ShoppingNotificationType.Info:
            return 'info';
        case _basketUpdated.ShoppingNotificationType.Success:
            return 'success';
        case _basketUpdated.ShoppingNotificationType.Warning:
        case _basketUpdated.ShoppingNotificationType.Reminding:
            return 'warning';
        default:
            return 'info';
    }
};
exports.getAlertSeverity = getAlertSeverity;
